export default {
  // 表单定义配置Url
  formItemsDefUrl: {
    type: String,
    default: null,
  },
  // 表单定义配置自定义数据，如果配置了 formItemsDefUrl 则此字段无效
  formItemsDefData: {
    type: Object,
  },
  gridEditStyle: {
    type: Object,
    default: null,
  },
  centerDefault: {
    type: Boolean,
    default: true,
  },
  //画布分成多少列
  colNum: {
    type: Number,
    default: 80,
  },
  //画布分成多少行
  rowNum: {
    type: Number,
    default: 45,
  },
  // 是否隐藏全屏按钮
  hideFullscreen: {
    type: Boolean,
    default: false,
  },
  // 大屏高度偏差值(单位是 px)
  offsetWidth: {
    type: Number,
    default: 0,
  },
  offsetHeight: {
    type: [String, Number],
    default: 192,
  },
}
